import { render, staticRenderFns } from "./cm-frotas.vue?vue&type=template&id=0c30d4b8&scoped=true&"
import script from "./cm-frotas.vue?vue&type=script&lang=js&"
export * from "./cm-frotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c30d4b8",
  null
  
)

export default component.exports